import React from 'react';
import { Toggle } from '@odin-labs/components';
import cn from 'classnames';
import { EditJobsiteConfigWorkerInfoField } from 'containers/jobsiteConfiguration/types';

export type WorkerInfoFieldProps = {
  onChange?: (e: EditJobsiteConfigWorkerInfoField) => void;
  value?: EditJobsiteConfigWorkerInfoField;
  name?: string;
  label?: string;
  description?: string;
  disabled?: boolean;
  className?: string;
  error?: React.ReactNode;
  showEnforced?: boolean;
};

const classes = {
  error: 'odin-mt-2 odin-text-sm odin-text-odin-danger',
};

export const WorkerInfoField = React.forwardRef(
  (
    props: WorkerInfoFieldProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ): React.ReactElement => {
    const {
      value,
      onChange,
      name,
      label,
      disabled,
      error,
      className,
      showEnforced,
    } = props;
    const {
      isRequired = false,
      isHidden = false,
      isEnforced = false,
    } = value ?? {};

    const renderError = (): React.ReactNode => {
      if (!error) return null;
      if (typeof error === 'string') {
        return <p className={classes.error}>{error}</p>;
      }
      return <div className={classes.error}>{error}</div>;
    };

    return (
      <div
        ref={ref}
        className={cn(className, 'odin-flex odin-justify-between')}
      >
        <div className="odin-text-sm odin-font-medium odin-text-gray-900">
          {label}
        </div>
        <div className="odin-flex odin-gap-x-5">
          <Toggle
            name={`${name}.isVisible`}
            label="Visible"
            value={!isHidden}
            disabled={disabled}
            onChange={(newValue): void => {
              onChange?.({
                isHidden: !newValue,
                isRequired: newValue ? isRequired : false,
                isEnforced: newValue ? isEnforced : false,
              });
            }}
          />
          <Toggle
            name={`${name}.isRequired`}
            label="Required"
            value={isRequired}
            onChange={(newValue): void => {
              onChange?.({
                isHidden,
                isRequired: newValue,
                isEnforced: newValue ? isEnforced : false,
              });
            }}
            disabled={disabled || isHidden}
          />
          <span className={cn(!showEnforced && 'odin-invisible')}>
            <Toggle
              name={`${name}.isEnforced`}
              label="Enforced"
              value={isEnforced}
              onChange={(newValue): void => {
                onChange?.({
                  isHidden,
                  isRequired,
                  isEnforced: newValue,
                });
              }}
              disabled={disabled || isHidden || !isRequired}
            />
          </span>
        </div>
        {renderError()}
      </div>
    );
  },
);
